class DipnTheme {
  constructor() {
    this.overlay = document.querySelector('[data-overlay]');
    this.menu = document.querySelector('[data-menu-drawer]');
    this.cart = document.querySelector('[data-cart-drawer]');
    this.search = document.querySelector('[data-search-modal]');
    this.filters = document.querySelector('[data-drawer="filters"]');
    this.header = document.querySelector('[data-site-header]');
    this.menuScrim = document.querySelector('[data-menu-scrim]');
    this.mobileNavDropdown = document.querySelector('[data-mobile-nav-dropdown]');
    this.navItems = [...document.querySelectorAll('[data-nav-item]')];
    this.bind();
  }

  bind() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-action]');
      if (trigger) {
        const action = trigger.dataset.action;
        if (action === 'open-menu') this.open(this.menu);
        if (action === 'open-cart') {
          this.open(this.cart);
          this.refreshCart();
        }
        if (action === 'open-search') this.open(this.search);
        if (action === 'close-all') this.closeAll();
      }

      const cartChange = event.target.closest('[data-cart-change]');
      if (cartChange) {
        event.preventDefault();
        this.changeCartItem(cartChange.dataset.lineKey, Number(cartChange.dataset.quantity));
        return;
      }

      const drawerTrigger = event.target.closest('[data-drawer-open]');
      if (drawerTrigger?.dataset.drawerOpen === 'filters') this.open(this.filters);
      if (event.target.closest('[data-drawer-close]')) this.closeAll();

      const submenuToggle = event.target.closest('[data-submenu-toggle]');
      if (submenuToggle) {
        event.preventDefault();
        const item = submenuToggle.closest('[data-nav-item]');
        if (item?.classList.contains('is-open')) this.closeNavItem(item);
        else this.openNavItem(item);
        return;
      }

      if (!event.target.closest('[data-nav-item]') && !event.target.closest('[data-menu-scrim]')) this.closeNavMenus();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeAll();
    });

    this.menuScrim?.addEventListener('click', () => this.closeNavMenus());
    this.navItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 1181px)').matches && item.querySelector('[data-nav-dropdown]')) this.openNavItem(item);
      });
      item.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 1181px)').matches) this.closeNavItem(item);
      });
      item.addEventListener('focusin', () => {
        if (window.matchMedia('(min-width: 1181px)').matches && item.querySelector('[data-nav-dropdown]')) this.openNavItem(item);
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) this.closeNavItem(item);
      });
    });

    if (this.header?.dataset.sticky === 'true') {
      this.updateHeader();
      window.addEventListener('scroll', () => this.updateHeader(), { passive: true });
    }
    window.addEventListener('resize', () => {
      this.updateScrimPosition();
      if (window.matchMedia('(max-width: 1180px)').matches) this.closeNavMenus();
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      const isQuickAdd = form.matches('.js-quick-add');
      const isProductAdd = form.matches('.product-form') && (!event.submitter || event.submitter.name === 'add');
      if (isQuickAdd || isProductAdd) this.addToCart(event);
    });

    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-cart-note]')) this.updateCartNote(event.target.value);
    });

    document.querySelectorAll('[data-product-root]').forEach((root) => this.bindProduct(root));
    document.querySelectorAll('[data-quantity], [data-quantity-picker]').forEach((root) => this.bindQuantity(root));
    document.querySelectorAll('[data-sort-by], [data-collection-sort]').forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.assign(url.toString());
      });
    });
    this.loadRecommendations();
  }

  open(panel) {
    this.closeAll();
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    this.overlay?.classList.add('is-open');
    document.body.classList.add('is-locked');
  }

  closeAll() {
    [this.menu, this.cart, this.search, this.filters].forEach((panel) => {
      panel?.classList.remove('is-open');
      panel?.setAttribute('aria-hidden', 'true');
    });
    this.overlay?.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    this.closeNavMenus();
  }

  openNavItem(item) {
    if (!item) return;
    this.navItems.forEach((entry) => {
      if (entry !== item) this.closeNavItem(entry, false);
    });
    item.classList.add('is-open');
    item.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'true');
    this.updateScrimPosition();
    const dropdown = item.querySelector('[data-nav-dropdown]');
    if (window.matchMedia('(max-width: 1180px)').matches && dropdown && this.mobileNavDropdown) {
      this.mobileNavDropdown.innerHTML = dropdown.innerHTML;
      this.mobileNavDropdown.classList.add('is-open');
      this.mobileNavDropdown.setAttribute('aria-hidden', 'false');
    } else {
      this.closeMobileNavDropdown();
    }
    this.menuScrim?.classList.add('is-open');
  }

  closeNavItem(item, hideScrim = true) {
    if (!item) return;
    const wasOpen = item.classList.contains('is-open');
    item.classList.remove('is-open');
    item.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
    if (wasOpen) this.closeMobileNavDropdown();
    if (hideScrim && !this.navItems.some((entry) => entry.classList.contains('is-open'))) this.menuScrim?.classList.remove('is-open');
  }

  closeNavMenus() {
    this.navItems.forEach((item) => this.closeNavItem(item, false));
    this.closeMobileNavDropdown();
    this.menuScrim?.classList.remove('is-open');
  }

  closeMobileNavDropdown() {
    if (!this.mobileNavDropdown) return;
    this.mobileNavDropdown.classList.remove('is-open');
    this.mobileNavDropdown.setAttribute('aria-hidden', 'true');
    this.mobileNavDropdown.innerHTML = '';
  }

  updateScrimPosition() {
    if (!this.header) return;
    document.documentElement.style.setProperty('--menu-scrim-top', `${Math.max(0, this.header.getBoundingClientRect().bottom)}px`);
  }

  updateHeader() {
    if (!this.header) return;
    const shouldCompact = window.scrollY > 120 && window.matchMedia('(min-width: 1181px)').matches;
    this.header.classList.toggle('is-compact', shouldCompact);
    if (this.navItems.some((item) => item.classList.contains('is-open'))) this.updateScrimPosition();
  }

  async addToCart(event) {
    event.preventDefault();
    const form = event.target;
    const button = event.submitter || form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
    const buttonLabel = button?.querySelector('[data-add-label]') || button;
    if (!button || !buttonLabel) return;
    const original = buttonLabel.textContent;
    const wasDisabled = button.disabled;
    button.disabled = true;
    buttonLabel.textContent = 'Adding…';
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Unable to add item');
      }
      const cart = await this.fetchCart();
      this.renderCart(cart);
      this.open(this.cart);
    } catch (error) {
      buttonLabel.textContent = error.message || 'Try again';
      setTimeout(() => {
        buttonLabel.textContent = original;
        button.disabled = wasDisabled;
      }, 1800);
      return;
    }
    button.disabled = wasDisabled;
    buttonLabel.textContent = original;
  }

  async fetchCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  async refreshCart() {
    if (!this.cart) return;
    this.setCartLoading(true);
    try {
      this.renderCart(await this.fetchCart());
    } catch (error) {
      this.showCartError(error.message);
    } finally {
      this.setCartLoading(false);
    }
  }

  async changeCartItem(lineKey, quantity) {
    if (!lineKey || Number.isNaN(quantity)) return;
    this.setCartLoading(true);
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: Math.max(0, quantity) })
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Unable to update cart');
      }
      this.renderCart(await response.json());
    } catch (error) {
      this.showCartError(error.message);
    } finally {
      this.setCartLoading(false);
    }
  }

  async updateCartNote(note) {
    this.setCartLoading(true);
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note })
      });
      if (!response.ok) throw new Error('Unable to save note');
      this.renderCart(await response.json(), true);
    } catch (error) {
      this.showCartError(error.message);
    } finally {
      this.setCartLoading(false);
    }
  }

  setCartLoading(loading) {
    if (!this.cart) return;
    this.cart.classList.toggle('is-loading', loading);
    this.cart.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  showCartError(message) {
    const body = this.cart?.querySelector('[data-cart-drawer-body]');
    if (!body) return;
    body.querySelector('.cart-drawer__error')?.remove();
    const error = document.createElement('p');
    error.className = 'cart-drawer__error';
    error.textContent = message || 'Something went wrong. Please try again.';
    body.prepend(error);
  }

  renderCart(cart, keepNoteOpen = false) {
    if (!this.cart) return;
    const body = this.cart.querySelector('[data-cart-drawer-body]');
    if (!body) return;

    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count;
    });

    if (!cart.item_count) {
      const productsURL = this.escapeHTML(this.cart.dataset.productsUrl || `${window.Shopify.routes.root}collections/all`);
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your bag is ready for something special.</p>
          <a class="button button--dark" href="${productsURL}">Explore the collection</a>
        </div>`;
      return;
    }

    const items = cart.items.map((item) => {
      const itemURL = this.escapeHTML(item.url || '#');
      const title = this.escapeHTML(item.product_title || item.title || 'Product');
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cart-drawer__variant">${this.escapeHTML(item.variant_title)}</p>`
        : '';
      const properties = Object.entries(item.properties || {})
        .filter(([name, value]) => value && !name.startsWith('_'))
        .map(([name, value]) => `<p class="cart-drawer__variant">${this.escapeHTML(name)}: ${this.escapeHTML(value)}</p>`)
        .join('');
      const image = item.image
        ? `<img src="${this.escapeHTML(this.cartImageURL(item.image, 320))}" width="140" height="140" loading="lazy" alt="${title}">`
        : '<span class="cart-drawer__image-placeholder" aria-hidden="true"></span>';
      const key = this.escapeHTML(item.key);
      const quantity = Number(item.quantity);

      return `
        <article class="cart-drawer__item" data-cart-line="${key}">
          <a class="cart-drawer__image" href="${itemURL}">${image}</a>
          <div class="cart-drawer__item-content">
            <div>
              <h3><a href="${itemURL}">${title}</a></h3>
              ${variantTitle}
              ${properties}
              <p class="cart-drawer__price">${this.escapeHTML(this.formatMoney(item.final_line_price))}</p>
            </div>
            <div class="cart-drawer__actions">
              <div class="cart-drawer__quantity" aria-label="Quantity">
                <button type="button" data-cart-change data-line-key="${key}" data-quantity="${Math.max(0, quantity - 1)}" aria-label="Decrease quantity">−</button>
                <span>${quantity}</span>
                <button type="button" data-cart-change data-line-key="${key}" data-quantity="${quantity + 1}" aria-label="Increase quantity">+</button>
              </div>
              <button class="cart-drawer__remove" type="button" data-cart-change data-line-key="${key}" data-quantity="0">Remove</button>
            </div>
          </div>
        </article>`;
    }).join('');

    const cartURL = this.escapeHTML(this.cart.dataset.cartUrl || `${window.Shopify.routes.root}cart`);
    const note = this.escapeHTML(cart.note || '');
    body.innerHTML = `
      <div class="cart-drawer__items">${items}</div>
      <div class="cart-drawer__footer">
        <details class="cart-drawer__note"${keepNoteOpen ? ' open' : ''}>
          <summary><span aria-hidden="true">+</span> Gift Note / Order Instructions</summary>
          <label class="visually-hidden" for="CartDrawerNote">Gift note or order instructions</label>
          <textarea id="CartDrawerNote" rows="3" data-cart-note placeholder="Add a note for your order">${note}</textarea>
        </details>
        <div class="cart-drawer__subtotal"><span>Subtotal</span><strong>${this.escapeHTML(this.formatMoney(cart.total_price))}</strong></div>
        <p class="cart-drawer__tax-note">Taxes and shipping are calculated at checkout.</p>
        <form action="${cartURL}" method="post">
          <button class="button button--dark button--full" type="submit" name="checkout">Checkout</button>
        </form>
      </div>`;
  }

  cartImageURL(source, width) {
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (_) {
      return source;
    }
  }

  escapeHTML(value) {
    return String(value ?? '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[character]);
  }

  bindQuantity(root) {
    const input = root.querySelector('input');
    root.querySelector('[data-minus], [data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value) - 1);
    });
    root.querySelector('[data-plus], [data-quantity-plus]')?.addEventListener('click', () => input.value = Number(input.value) + 1);
  }

  bindProduct(root) {
    const variantsScript = root.querySelector('[data-product-json], [data-product-variants]');
    const form = root.querySelector('[data-product-form], .product-form');
    if (!variantsScript || !form) return;
    const variants = JSON.parse(variantsScript.textContent);
    const idInput = form.querySelector('[name="id"]');
    const addButton = form.querySelector('[name="add"]');
    const price = root.querySelector('[data-product-price]');
    const addLabel = form.querySelector('[data-add-label]');
    const status = root.querySelector('[data-product-status]');

    root.querySelectorAll('[data-option-swatch]').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const optionIndex = swatch.dataset.optionIndex;
        const optionValue = swatch.dataset.optionValue;
        const select = root.querySelector(`select[data-option-index="${optionIndex}"]`);
        if (!select) return;

        root.querySelectorAll(`[data-option-swatch][data-option-index="${optionIndex}"]`).forEach((entry) => {
          const active = entry === swatch;
          entry.classList.toggle('is-active', active);
          entry.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        const valueLabel = root.querySelector(`[data-option-value-label="${optionIndex}"]`);
        if (valueLabel) valueLabel.textContent = optionValue;
        select.value = optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    root.querySelectorAll('select[data-option-index]').forEach((select) => {
      select.addEventListener('change', () => {
        const selectedValueLabel = root.querySelector(`[data-option-value-label="${select.dataset.optionIndex}"]`);
        if (selectedValueLabel) selectedValueLabel.textContent = select.value;
        const options = [...root.querySelectorAll('select[data-option-index]')].map((element) => element.value);
        const variant = variants.find((entry) => entry.options.every((option, index) => option === options[index]));
        if (!variant) {
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
          return;
        }
        idInput.value = variant.id;
        addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
        if (status) {
          status.textContent = variant.available ? 'In stock, and ready to ship' : 'Out of stock';
          status.classList.toggle('is-unavailable', !variant.available);
        }
        if (price) price.textContent = this.formatMoney(variant.price);
        if (variant.featured_media) {
          const mediaId = String(variant.featured_media.id);
          const mediaThumb = root.querySelector(`[data-gallery-thumb="${mediaId}"]`);
          if (mediaThumb) mediaThumb.click();
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      });
    });

    root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        root.querySelectorAll('[data-gallery-thumb]').forEach((entry) => entry.classList.remove('is-active'));
        root.querySelectorAll('[data-gallery-media]').forEach((entry) => entry.classList.remove('is-active'));
        thumb.classList.add('is-active');
        root.querySelector(`[data-gallery-media="${thumb.dataset.galleryThumb}"]`)?.classList.add('is-active');
      });
    });

    const thumbnailRail = root.querySelector('.product-gallery__thumbs');
    root.querySelectorAll('[data-gallery-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!thumbnailRail) return;
        const direction = button.dataset.galleryScroll === 'up' ? -1 : 1;
        thumbnailRail.scrollBy({ top: direction * 180, behavior: 'smooth' });
      });
    });
  }

  async loadRecommendations() {
    const root = document.querySelector('[data-product-recommendations]');
    if (!root || !root.dataset.url) return;
    try {
      const html = await fetch(root.dataset.url).then((response) => response.text());
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const replacement = documentFragment.querySelector('[data-product-recommendations]');
      if (replacement?.innerHTML.trim()) root.innerHTML = replacement.innerHTML;
    } catch (_) {
      /* Recommendations are optional; leave the section empty if unavailable. */
    }
  }

  formatMoney(cents) {
    const format = window.dipnMoneyFormat || '{{amount}} EGP';
    const match = format.match(/\{\{\s*(amount(?:_no_decimals)?(?:_with_(?:comma|apostrophe)_separator)?)\s*\}\}/);
    if (!match) return `${(cents / 100).toFixed(2)} EGP`;

    const token = match[1];
    const noDecimals = token.includes('no_decimals');
    const commaSeparator = token.includes('comma_separator');
    const apostropheSeparator = token.includes('apostrophe_separator');
    let amount = (Number(cents) / 100).toFixed(noDecimals ? 0 : 2);
    let [whole, decimal] = amount.split('.');
    const thousands = apostropheSeparator ? "'" : (commaSeparator ? '.' : ',');
    const decimalMark = commaSeparator ? ',' : '.';
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    amount = noDecimals ? whole : `${whole}${decimalMark}${decimal}`;
    return format.replace(match[0], amount).replace(/<[^>]*>/g, '');
  }
}

document.addEventListener('DOMContentLoaded', () => new DipnTheme());
